// execute a CommonJS module body with real module/exports objects, returning the final exports
__webpack_require__.cjs = function(body) {
	var mod = { exports: {} };
	body.call(mod.exports, mod, mod.exports);
	return mod.exports;
};